import posthog from "posthog-js";

let initialized = false;

function readPublicEnv(name: "BUN_PUBLIC_POSTHOG_KEY" | "BUN_PUBLIC_POSTHOG_HOST"): string | undefined {
  const env = import.meta.env;
  if (!env || typeof env !== "object") return undefined;
  const v = (env as Record<string, string | undefined>)[name];
  return typeof v === "string" && v.trim().length > 0 ? v.trim() : undefined;
}

/** Call once before render. No-ops when `BUN_PUBLIC_POSTHOG_KEY` is missing. */
export function initPostHog(): void {
  if (initialized) return;
  const key = readPublicEnv("BUN_PUBLIC_POSTHOG_KEY");
  if (!key) return;

  const apiHost = readPublicEnv("BUN_PUBLIC_POSTHOG_HOST");
  posthog.init(key, {
    ...(apiHost ? { api_host: apiHost } : {}),
    defaults: "2026-01-30",
  });
  initialized = true;
}

/** Safe to call from handlers; only sends when PostHog was initialized. */
export function capturePostHog(event: string, properties?: Record<string, unknown>): void {
  if (!initialized) return;
  try {
    posthog.capture(event, properties);
  } catch {
    /* ignore */
  }
}
